<template>
  <v-container fluid fill-height class="home-hero" style="max-height: 100vh;">
    <v-layout justify-center align-center column pa-5>
      <div
        class="font-weight-bold primarylighten--text text-xs-center"
        style="font-size: 10vw;"
      >Dan & Anan Wedding 2019</div>
      <div class="font-weight-bold white--text text-xs-center">
        <h6>We can't wait to celebrate with you!
          <br>执子之手 与子偕老
        </h6>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'HomeHero',
};
</script>

<style scoped>
.home-hero {
  background: url('../assets/photos/hero/IMG_9094.jpg');
  background-size: cover;
  background-position: center;
}
h6 {
  font-size: 44px;
  padding: 5;
}
@media (min-width: 100px) {
  h6 {
    font-size: 20px;
  }
}
@media (min-width: 600px) {
  h6 {
    font-size: 28px;
    padding: 5;
  }
}
@media (min-width: 960px) {
  h6 {
    font-size: 34px;
  }
}
</style>
